/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S18_I5_LabelInputs */

const tr_kullanim_s18_i5_label = /** @type {(inputs: Kullanim_S18_I5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebligat:`)
};

const en_kullanim_s18_i5_label = /** @type {(inputs: Kullanim_S18_I5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications:`)
};

const de_kullanim_s18_i5_label = /** @type {(inputs: Kullanim_S18_I5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zustellung:`)
};

const ru_kullanim_s18_i5_label = /** @type {(inputs: Kullanim_S18_I5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления:`)
};

/**
* | output |
* | --- |
* | "Notifications:" |
*
* @param {Kullanim_S18_I5_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s18_i5_label = /** @type {((inputs?: Kullanim_S18_I5_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S18_I5_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s18_i5_label(inputs)
	if (locale === "de") return de_kullanim_s18_i5_label(inputs)
	if (locale === "ru") return ru_kullanim_s18_i5_label(inputs)
	return tr_kullanim_s18_i5_label(inputs)
});